<template>
  <div>
    Dashboard coming soon...
  </div>
</template>

<script>

export default {
  name: 'Dashboard'
}
</script>
